export default __webpack_public_path__ + "static/media/television.9ca6dd0b.svg";